/**
 * Helper: Cart functions
 * -----------------------------------------------------------------------------
 * Global configuration for adding and removing from card.
 * test
 * Fire's event bus to trigger all other functions.
 */
import * as cart from '@shopify/theme-cart';
import cssClasses from './cssClasses';
import { on } from './utils';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-cart="container"]',
  addToCart: '[js-cart="addToCart"]',
  quickAddSimple: '[js-cart="quickAddSimple"]',
  remove: '[js-cart="remove"]',
  error: '[js-cart="error"]',
};

/**
 * Text Strings. 
 */
const strings = {
  buttonDefault: theme.strings.addToCart,
  buttonLoading: theme.strings.addingToCart,
  addToCartError: 'Looks like something went wrong',
};

/**
 * Export default cartFunctions.
 */
export default () => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    addToCart: [...document.querySelectorAll(selectors.addToCart)],
    container: [...document.querySelectorAll(selectors.container)],
  };

  /**
   * Handle add to cart event.
   * @param {Object} event - Submited event.
   * @param {HTMLElement} form - Submited form.
   */
  function handleAddToCart(event, form) {
    event.preventDefault();
    setLoadingState(form);
    clearErrorState(form);

    let _bundle = form;

    // console.log(form)

    if(_bundle.getAttribute('data-is-bundle') == "true") {
      let primaryParent = _bundle.getAttribute('data-bundle-product-id');
      let option1 = _bundle.querySelector('#bundle-items').getAttribute('data-bundle-option-1');
      let option2 = _bundle.querySelector('#bundle-items').getAttribute('data-bundle-option-2');
      let name1 = _bundle.querySelector('#bundle-items').getAttribute('clean-option-1');
      let name2 = _bundle.querySelector('#bundle-items').getAttribute('clean-option-2');

      let formData = {
        items: [
          {
            id: primaryParent,
            quantity: 1,
            properties: {
              _bundle_parent: true,
              _bundle_item_1: option1,
              _bundle_item_2: option2,
              _bundle_item_1_name: name1,
              _bundle_item_2_name: name2
            }
          }
        ]
       };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then((res)=>{
        Karmoon.EventBus.emit('AddToCart:itemAdded', res);
        setDefaultState(form);
        console.log('added v2: ', res);
      })
      .catch((err)=>{
        console.log(err);
      })

    } else {
      cart
      .addItemFromForm(form)
      .then((item) => {
        Karmoon.EventBus.emit('AddToCart:itemAdded', item);
        setDefaultState(form);
      })
      .catch((error) => {
        Karmoon.EventBus.emit('AddToCart:error', form, error);
        setDefaultState(form);
        setErrorState(form);
        return error;
      });
    }

  }


  function addSample(samples) {

    if(samples ==  null || samples == undefined){
    } else {
      let _items = samples.querySelector('#all-samples').dataset;
      let ids = [];

      for( var i in _items){
        ids.push({'id': _items[i], 'quantity': 1})
      }

      let formData = {
        'items': ids
       };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then((res)=>{
        Karmoon.EventBus.emit('AddToCart:itemAdded', res);
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    }
  }


  /**
   * Handle add to cart event.
   * @param {Object} event - Submited event.
   * @param {HTMLElement} form - Submited form.
   */
  function handleQuickAdd(event) {
    event.preventDefault();
    const form = event.target;
    const id = parseInt(form.dataset.variantId);
    const quantity = parseInt(form.dataset.quantity);

    cart
      .addItem(id, { quantity })
      .then((item) => {
        Karmoon.EventBus.emit('AddToCart:itemAdded', item);
      })
      .catch((error) => {
        return error;
      });
  }


  async function clearCart() {

    if(document.querySelector('#cs-wrapper')) {
      document.querySelector('#cs-wrapper').classList.add('visually-hidden');
    }

    if(document.querySelector('#fg-wrapper')) {
      document.querySelector('#fg-wrapper').classList.add('visually-hidden');
    }

    if(document.querySelector('#sample-prompt')) {
      document.querySelector('#sample-prompt').classList.add('visually-hidden');
    }

    const cart = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    })

    const cartData = await cart.json();
    return cartData;
  }

  async function clearSamples(d) {

    let updates = {};

    for (let i in d) {
      updates[d[i]] = 0;
    }

    const cart = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    const cartData = await cart.json();
    return cartData;
  }

  async function checkForGift() {
    const cart = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    })

    const cartData = await cart.json();

    const _freeGift = document.querySelector(`[gift-ref]`);
    const _freeGift2 = document.querySelector(`[freegift-ref]`);

    if(cartData?.total_price == 0) {

      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.add('disabled');
      }

      await clearCart();
      Karmoon.EventBus.emit('AddToCart:itemRemoved');

      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.remove('disabled');
      }
    }

    if(cartData.item_count == 0) {
      if(_freeGift) {
        _freeGift.hide();
      }

      if(_freeGift2) {
        _freeGift2.hide();
      }
    } else if(cartData.item_count == 1) {
      if(cartData?.items[0]?.properties?._gift_item == true) {
        await clearCart();
        Karmoon.EventBus.emit('AddToCart:itemRemoved');

        if(document.querySelector('#cs-wrapper')) {
          document.querySelector('#cs-wrapper').classList.add('visually-hidden');
        }

        if(document.querySelector('#sample-prompt')) {
          document.querySelector('#sample-prompt').classList.add('visually-hidden');
        }
      }
    } else if(cartData.item_count == 2) {

      const items = cartData?.items;
      let thresholdCount = 0;
      let idToRemove = '';

      items.map((i) => {
        if(i?.product_type == "Gift Card") {
          thresholdCount = thresholdCount + 1;
        } else if (i?.properties?._gift_item == true) {
          thresholdCount = thresholdCount + 1;
          idToRemove = i?.key
        }
      })

      if(thresholdCount === 2) {

        const updates = {[idToRemove]: 0};
  
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          return response.json();
        })
        .then(()=>{
          Karmoon.EventBus.emit('AddToCart:itemRemoved');
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      }
    } else if(cartData.item_count == 3) {
      const items = cartData?.items;
      let normalCount = 0;

      items.map((i) => {
        if(i?.properties?._sample_item == true) {
          normalCount = normalCount + 0;
        } else if (i?.properties?._gift_item == true) {
          normalCount = normalCount + 0;
        } else {
          normalCount = normalCount + 1;
        }
      })

      if(normalCount == 0) {
        await clearCart();
        Karmoon.EventBus.emit('AddToCart:itemRemoved');
      }
    }

    let giftCounter = 0;
    let freeGiftCounter = 0;
    let normalCount = 0;

    let samplesToRemove = [];

    cartData?.items?.map((i) => {
      if (i?.properties?._sample_item == true) {
        giftCounter = giftCounter + i?.quantity;
      }

      if (i?.properties?._gift_item == true) {
        freeGiftCounter = freeGiftCounter + i?.quantity;
      }

      if(i?.product_type == "Gift Card") {

      } else if(i?.product_type == "Sample") {
        samplesToRemove.push(i?.key);
      } else {
        normalCount = normalCount + i?.quantity
      }
    });

    if(normalCount == 0) {
      await clearSamples(samplesToRemove);
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    } else if(giftCounter == cartData.item_count) {
      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.add('disabled');
      }
      await clearCart();
      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.remove('disabled');
      }
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    } else if(freeGiftCounter == 0) {
      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.add('disabled');
      }
    
      if(document.querySelector('#fg-wrapper')) {
        document.querySelector('#fg-wrapper').classList.remove('visually-hidden');
      }

      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.remove('disabled');
      }
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    }  else {
      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.remove('disabled');
      }
      return null;
    }

  }

  if(document.querySelector('#sample-prompt')) {
    document.querySelector('#sample-prompt').addEventListener('click', (e) => {
      document.getElementById('cs-wrapper').scrollIntoView();
    })
  }

  /**
   * Handle update quantity from cart event.
   * @param {Object} event - Submit event.
   */
  function handleRemoveFromCart(event) {
    event.preventDefault();
    const item = event.target;
    const key = item.dataset.itemKey;

    if(document.querySelector('.button--checkout')) {
      document.querySelector('.button--checkout').classList.add('disabled');
    }

    Karmoon.EventBus.emit('AddToCart:isRemoving');

    // If the line item is a bundle product, we run a special remove from cart function
    if(item.getAttribute('data-bundle-remove') == "true"){

      let isBundleParent = item.getAttribute('data-bundle-remove');
      let toRemove = item.getAttribute('data-to-remove');
      let bundle_key = item.getAttribute('data-bundle-id');

      let itemsToRemove = [];

      document.querySelectorAll(`.cart-data[data-bundle-id="${bundle_key}"]`).forEach((el)=>{
        itemsToRemove.push(el.getAttribute('data-key'));
      })

      // form an array from the data ids thata re attached to the 'Bundle'
      // let itemsToRemove = toRemove.split(',');
      // // add the parent bundle id to the remove array
      // itemsToRemove.push(key);

      // console.log(itemsToRemove);

      // create the object of IDs to remove from the cart
      const updates = {};
      for (const key of itemsToRemove) {
        updates[key] = 0;
      }

      // console.log(updates);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        return response.json();
      })
      .then(()=>{
        Karmoon.EventBus.emit('AddToCart:itemRemoved');
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    } else {
      cart.removeItem(key).then(() => {
        checkForGift();
        Karmoon.EventBus.emit('AddToCart:itemRemoved');
      });
    }
  }

  /**
   * Handle add to cart loading state.
   * @param {HTMLElement} form - Submited form.
   */
  function setLoadingState(form) {
    const addToCartButton = form.querySelector(selectors.addToCart);
    addToCartButton.innerHTML = strings.buttonLoading;
  }

  /**
   * Clear add to cart error state.
   * @param {HTMLElement} form - Submited form.
   */
  function clearErrorState(form) {
    const addToCartError = form.querySelector(selectors.error);
    addToCartError.innerHTML = '';
    addToCartError.classList.remove(cssClasses.active);
  }

  /**
   * Set Error on Form.
   * @param {HTMLElement} form - Submited form.
   */
  function setErrorState(form) {
    const addToCartError = form.querySelector(selectors.error);
    addToCartError.innerHTML = strings.addToCartError;
    addToCartError.classList.add(cssClasses.active);
  }

  /**
   * Handle add to cart default state.
   * @param {HTMLElement} form - Submited form.
   */
  function setDefaultState(form) {
    const addToCartButton = form.querySelector(selectors.addToCart);
    addToCartButton.innerHTML = strings.buttonDefault;
  }

  /**
   * Set Event Listeners.
   */
  function setEventListeners() {
    nodeSelectors.container.forEach((form) => {
      on('submit', form, (event) => handleAddToCart(event, form));
    });

    document.addEventListener('click', function (event) {
      // All click events will be handled by this function, so it needs to be as cheap as possible. To check
      // whether this function should be invoked, we're going to check whether the element that was clicked on
      // was the elemnt that we care about. The element that was clicked on is made available at "e.target"
      const element = event.target;

      // Check if it matches our previously defined selector
      if (element.matches(selectors.remove)) {
        handleRemoveFromCart(event);
      }

      if (element.matches(selectors.quickAddSimple)) {
        handleQuickAdd(event);
      }
    });
  }

  function init() {
    setEventListeners();
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};


/**
   * Detect quick view toggle click.
   * @param {HTMLElement} target - Clicked target to check quick view attributes against.
   * @returns {Boolean}
   */
  // function isTargetToggle(target) {
  //   return (
  //     typeof target.attributes[dataSelectors.quickView] !== 'undefined' &&
  //     target.attributes[dataSelectors.quickView].nodeValue === 'toggle'
  //   );
  // }
